(function (angular) {
  "use strict";

  /*
   *
   * Created by: Edouard Riviere
   * Ported to AngularJS in 2019 (and destined for almost immediate destruction) by: Martin Funcich
   *
   */

  /* Directives */
  angular.module("Toyota.Legacy").service("linkToSlide", [
    "$rootScope",
    function ($rootScope) {
      function init(cfg) {
        $.extend(this, cfg);
        attachEvents();

        var hashParams = parseFragment();
        if (hashParams) {
          $rootScope.$broadcast("slide-to", hashParams);
        }
      }

      function attachEvents() {
        $rootScope.$on("slide-to", scrollToSlide);
        $rootScope.$on("slide-to", scrollToSlideMobile);
      }

      function parseFragment() {
        var hashParams = {
          section: null,
          element: null,
        };

        var a = /\+/g; // Regex for replacing addition symbol with a space
        var decode = function (s) {
          return decodeURIComponent(s.replace(a, " "));
        };

        var urlHash = window.location.hash.substring(1);

        if (urlHash.indexOf("=") === -1) {
          return $.extend(hashParams, { section: urlHash });
        }

        var match = RegExp.exec(urlHash);
        while (match) {
          hashParams[decode(match[1])] = decode(match[2]);
          match = RegExp.exec(urlHash);
        }

        return hashParams;
      }

      /*
       * @param msg {string} event name. Not really used in this function, but passed with $rootScope.
       * @param data {object} Params sent in the url
       */
      function scrollToSlide(msg, slideToData) {
        var $section = angular.element("#" + slideToData.section)[0];
        if ($section) {
          $section.scrollIntoView();
          $rootScope.$broadcast("slide-to/callback", slideToData);
        }
      }

      function scrollToSlideMobile(msg, slideToData) {
        var offset = angular
          .element("#" + slideToData.tab)
          .prev()
          .offset();
        var positionTop = offset && offset.top;
        if (positionTop) {
          window.scrollTo(0, positionTop);
        }

        $rootScope.$broadcast("slide-to/callback", slideToData);
      }

      return {
        init: init,
      };
    },
  ]);
})(window.angular);
